<nav class="navbar navbar-dark bg-primary">
    <br/>
    <h1 class="font-weight-bold" style="color:white">
        ACREDITACIONES DE ACTUARIOS Y AUDITORES EXTERNOS
    </h1>
</nav>
